import Vue from 'vue'
import Router from 'vue-router'
import community from './community/index'
import my from './my/index'
import find from './find/index'
import original from './original/index'
import video from './video/index'
import Vocal from './find/vocal_novels/index'
import text_Novels from './find/text_Novels/index'
import Comic from './find/comic/index'
import Appdownload from './find/down/index'
import Comic_details from './find/comic/comic_details/index'
import original_wise from './find/original/index'

Vue.use(Router)

let routes = new Set([...community, ...my, ...find, ...original, ...video, ...Vocal, ...text_Novels, ...Comic, ...Appdownload, ...Comic_details,...original_wise]);
export default new Router({
    mode: 'hash',
    routes,
    // scrollBehavior(to, from, savedPosition) {
    //     if (savedPosition) {
    //         return savedPosition
    //     } else {
    //         return {
    //             x: 0,
    //             y: 0
    //         }
    //     }
    // },
})


// WEBPACK FOOTER //
// ./src/router/index.js